import { dateFormat, decryptedValue, downloadDocument, uId } from "common/utility";
import CommonDialog from "components/Common/CommonDialog";
import DeleteModal from "components/Common/DeleteModal";
import TableContainerV1 from "components/Common/TableContainerV1";
import ToastDialog from "components/Common/ToastDialog";
import API_SERVICES from "constants/app.constants";
import { useFormik } from "formik";
import { callBankList } from "http/fundLync/common.helper";
import { getDropDownList } from "http/fundLync/dropdown.helper";
import {
  callBSADeleteRecord,
  callBSAFileUpload,
  callBSAMergeSubmit,
  callBankStatementLists,
} from "http/fundLync/entityDocuments.helper";
import { startCase } from "lodash";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDropzone } from "react-dropzone";
import Select from "react-select";
import { useAsyncDebounce } from "react-table";
import { Col, Form, FormFeedback, Input, Label } from "reactstrap";
import * as Yup from "yup";

const TableActionsComponent = (deleteClickFn) => {
  return (
    <div style={{ display: "flex", gap: "10px" }}>
      <i
        className="mdi  mdi-trash-can-outline action-icon"
        title="Delete"
        onKeyUp={() => { }}
        onClick={() => {
          deleteClickFn();
        }}
      ></i>
    </div>
  );
};

const TableFileComponent = (value, isPendingFile, fileDownloadFn) => {
  if (value && !isPendingFile) {
    return (
      <i
        className="mdi mdi-file-download-outline action-icon"
        onClick={fileDownloadFn}
        onKeyUp={() => { }}
      ></i>
    );
  } else if (isPendingFile) {
    return <span>Pending</span>;
  } else {
    return <></>;
  }
};

const BSADocuments = (props) => {
  document.title = "BSA Documents | FundLync";
  const urlParams = new URLSearchParams(window.location.search);
  // const encodedId = urlParams.get("id");
  // const entityId = atob(encodedId);
  
  const [entityId, setEntityId] = useState('')
  const [encodedId, setEncodedId] = useState('')
  const [showCommonDialog, setShowCommonDialog] = useState({ isShow: false });
  const [toastInfo, setToastInfo] = useState({ showToast: false });
  const [loading, setLoading] = useState(false);
  const [bsaFileList, setBsaFileList] = useState([]);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [dialogObj, setDialogObj] = useState();
  const [uploadProgress, setUploadProgress] = useState(0);
  const [errorMessage] = useState(null);
  const [bankSelectedGroup, setBankSelectedGroup] = useState(null);
  const [entityTypeSelected, setEntityTypeSelected] = useState(null);
  const [acTypeSelected, setAcTypeSelected] = useState(null);
  const [acTypeSelectedOptions, setAcTypeSelectedOptions] = useState([]);
  const [bankList, setBankList] = useState([]);
  const [isBankLoading, setIsBankLoading] = useState(false);
  const [clickMergeFile, setClickMergeFile] = useState(false);
  const [selectedRefIds, setSelectedRefIds] = useState([]);
  const onDrop = useCallback((acceptedFiles) => {
    const selectedFile = acceptedFiles;
    if (selectedFile.length > 12) {
      setToastInfo({
        message: "Max 12 files allowed",
        showToast: true,
        role: "error",
      });
      return;
    }
    if (selectedFile) {
      const fileList = [];
      const totalFiles = selectedFile.length;
      for (let index = 0; index < totalFiles; index++) {
        const file = selectedFile[index];
        fileList.push(file);
      }
      validationFileUpload.setFieldValue("fileUpload", fileList);
    } else {
      validationFileUpload.setFieldValue("fileUpload", []);
    }
    validationFileUpload.validateForm();
  }, []);
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
  });

  const bankValueChange = useAsyncDebounce((value) => {
    loadBankList(value);
  }, 500);
  
  useEffect(()=>{
    const userDetails = decryptedValue(localStorage.getItem("user"));
      if(userDetails.entityType === "Partner" || userDetails.entityType === "Owner"){
        setEncodedId(urlParams.get("id"))
        setEntityId(atob(encodedId))
      }else{
        setEncodedId(entityId)
        setEntityId(userDetails.entityId)
      }
  },[ entityId, encodedId])

  const handleChange = (e, rowData) => {
    const { checked } = e.target;
    if (checked) {
      setSelectedRefIds((prevSelectedRefIds) => [
        ...prevSelectedRefIds,
        rowData.refId,
      ]);
    } else {
      setSelectedRefIds((prevSelectedRefIds) =>
        prevSelectedRefIds.filter((id) => id !== rowData.refId)
      );
    }
  };

  const bsaColumns = useMemo(
    () => [
      {
        Header: "Name",
        accessor: "params",
        filterable: true,
        Cell: (cellProps) => {
          const params = cellProps.value;
          try {
            const jsonValue = JSON.parse(params);
            return jsonValue.entityName || "-";
          } catch (error) {
            return "";
          }
        },
      },
      {
        Header: "Account Number",
        accessor: "account_number",
        filterable: true,
        Cell: (cellProps) => {
          const rowData = cellProps.row.original;
          const params = rowData.params;
          try {
            const jsonValue = JSON.parse(params);
            return jsonValue.accountNumber || "-";
          } catch (error) {
            return "";
          }
        },
      },
      {
        Header: "PAN",
        accessor: "pan",
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value || "-";
        },
      },
      {
        Header: "Status",
        accessor: "statusMsg",
        filterable: true,
        Cell: (cellProps) => {
          return startCase(cellProps.value) || "";
        },
      },
      {
        Header: "Updated On",
        accessor: "createdAt",
        filterable: true,
        Cell: (cellProps) => {
          return dateFormat(cellProps.value || "", "DD-MM-YYYY");
        },
      },
      {
        Header: "Bank Statement Uploaded",
        accessor: "file",
        Cell: (cellProps) => {
          return TableFileComponent(cellProps.value, false, () => {
            downloadDocument(cellProps.value);
          });
        },
      },
      {
        Header: "Bank Statement Report",
        accessor: "responseFile",
        Cell: (cellProps) => {
          return TableFileComponent(cellProps.value, !cellProps.value, () => {
            downloadDocument(cellProps.value);
          });
        },
      },
      {
        Header: "Report Status",
        accessor: "isMerged",
        Cell: (cellProps) => {
          return (cellProps.value ? "Merged" : "-") || "-";
        },
      },
      {
        Header: "Action",
        Cell: (cellProps) => {
          const rowData = cellProps.row.original;
          return TableActionsComponent(() => {
            setDialogObj(rowData);
            setDeleteDialog(true);
          });
        },
      },
    ],
    []
  );

  const bsaColumnforMergeFile = useMemo(
    () => [
      {
        Header: "#",
        Cell: (cellProps) => {
          const rowData = cellProps.row.original;
          return (
            <input
              type="checkbox"
              checked={rowData.selected}
              onChange={() => { }}
              onClick={(e) => {
                handleChange(e, rowData);
              }}
              className="form-check-input"
              disabled={rowData.isMerged}
            />
          );
        },
      },
      {
        Header: "Name",
        accessor: "params",
        filterable: true,
        Cell: (cellProps) => {
          const params = cellProps.value;
          try {
            const jsonValue = JSON.parse(params);
            return jsonValue.entityName || "-";
          } catch (error) {
            return "";
          }
        },
      },
      {
        Header: "Account Number",
        accessor: "account_number",
        filterable: true,
        Cell: (cellProps) => {
          const rowData = cellProps.row.original;
          const params = rowData.params;
          try {
            const jsonValue = JSON.parse(params);
            return jsonValue.accountNumber || "-";
          } catch (error) {
            return "";
          }
        },
      },
      {
        Header: "PAN",
        accessor: "pan",
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value || "-";
        },
      },
      {
        Header: "Status",
        accessor: "statusMsg",
        filterable: true,
        Cell: (cellProps) => {
          return startCase(cellProps.value) || "";
        },
      },
      {
        Header: "Updated On",
        accessor: "createdAt",
        filterable: true,
        Cell: (cellProps) => {
          return dateFormat(cellProps.value || "", "DD-MM-YYYY");
        },
      },
      {
        Header: "Bank Statement Uploaded",
        accessor: "file",
        Cell: (cellProps) => {
          return TableFileComponent(cellProps.value, false, () => {
            downloadDocument(cellProps.value);
          });
        },
      },
      {
        Header: "Bank Statement Report",
        accessor: "responseFile",
        Cell: (cellProps) => {
          return TableFileComponent(cellProps.value, !cellProps.value, () => {
            downloadDocument(cellProps.value);
          });
        },
      },
      {
        Header: "Report Status",
        accessor: "isMerged",
        Cell: (cellProps) => {
          return (cellProps.value ? "Merged" : "-") || "-";
        },
      },
      {
        Header: "Action",
        Cell: (cellProps) => {
          const rowData = cellProps.row.original;
          return TableActionsComponent(() => {
            setDialogObj(rowData);
            setDeleteDialog(true);
          });
        },
      },
    ],
    []
  );

  const validationFileUpload = useFormik({
    enableReinitialize: true,

    initialValues: {
      pan: "",
      entityType: "",
      bank: "",
      acType: "",
      acName: "",
      acNumber: "",
      overdraftLimit: "",
      fileUpload: [],
    },
    validationSchema: Yup.object({
      pan: Yup.string()
        .matches(API_SERVICES.PAN_PATTERN, "Enter valid PAN pattern")
        .required("PAN is required"),
      entityType: Yup.string().required("Entity type is required"),
      acType: Yup.string().required("Account type is required"),
      bank: Yup.string().required("Bank is required"),
      acName: Yup.string().required("Account name is required"),
      acNumber: Yup.string().required("Account number is required"),
      fileUpload: Yup.array()
        .min(1, "At least 1 file required")
        .max(12, "Max 12 file allowed")
        .test("fileType", "Invalid file type. Only images and PDFs are allowed.", (value) => {
          if (!value) return true;
          return value.every(file => {
            const allowedFileTypes = ['image/jpeg', 'image/png', 'application/pdf', 'image/jpg'];
            return allowedFileTypes.includes(file.type);
          });
        })
        .required("Upload file is required"),
    }),
    onSubmit: (values) => {
      setShowCommonDialog({
        isShow: true,
        data: { type: "bsa" },
        message: "Are you sure want to submit Bank Details?",
      });
    },
  });

  useEffect(() => {
    loadAccountTYpeDropdown();
    loadBankList();
    if(entityId){
      loadBSAListData();
    }
  }, [entityId]);

  const loadAccountTYpeDropdown = () => {
    getDropDownList({ dropdownName: "bankType" })
      .then((response) => {
        const dropdownValues =
          response.data?.rows?.find((dv) => dv.dropdownName == "bankType")
            ?.dropdownValues || [];
        setAcTypeSelectedOptions(dropdownValues);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const loadBSAListData = async () => {
    const postParams = {
      entity_id: entityId,
      type: "bsa",
    };
    callBankStatementLists(postParams)
      .then((response) => {
        if (response.code == 200 && response.status) {
          const { data } = response;
          setBsaFileList(data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const loadBankList = (search) => {
    setIsBankLoading(true);
    callBankList({ page: 1, limit: 100, searchKey: search })
      .then((response) => {
        setBankList(response.data?.data || []);
        setIsBankLoading(false);
      })
      .catch((error) => {
        setIsBankLoading(false);
        console.log(error);
      });
  };

  const submitBSAFileUpload = async (value) => {
    setLoading(true);
    const postparams = {
      payload: {
        accountType: value.acType,
        accountNumber: value.acNumber,
        pan: value.pan,
        entityName: value.acName,
        entityType: value.entityType,
        bankCode: value.bank,
        sanctionLimit: value.overdraftLimit,
        password: value.statementPassword,
      },
      entityId: entityId,
    };

    const config = {
      headers: { "content-type": "multipart/form-data" },
      onUploadProgress: (progressEvent) => {
        const percentage = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        setUploadProgress(percentage);
      },
    };
    // const cleanedFilename = value.fileUpload[0].file.path.replace(/\s+/g, '');
    // const originalFilename = fileDetails[i].originalname.replace(/\s+/g, '');
   
    // fileDetails[i].filename = cleanedFilename
    callBSAFileUpload(postparams, value.fileUpload, config)
      .then((response) => {
        setLoading(false);
        if (response.code == 200 && response.status) {
          const { message } = response;
          setToastInfo({ message: message, showToast: true, role: "success" });
          validationFileUpload.resetForm();

          setBankSelectedGroup(null);
          setEntityTypeSelected(null);
          setBankSelectedGroup(null);
          setAcTypeSelected(null);
          setUploadProgress(0);
          loadBSAListData();
        } else {
          const { message } = response;
          setToastInfo({ message: message, showToast: true, role: "error" });
        }
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const deleteBSARecord = () => {
    setDeleteDialog(false);

    const postParams = {
      id: dialogObj?.id,
    };

    callBSADeleteRecord(postParams)
      .then((response) => {
        if (response.code == 200 && response.status) {
          const { message } = response;
          setToastInfo({ message: message, showToast: true, role: "success" });
          setDialogObj(null);
          loadBSAListData();
        } else {
          const { message } = response;
          setToastInfo({ message: message, showToast: true, role: "error" });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const dialogAction = (action, data) => {
    if (data.type == "bsa" && action == 1) {
      setShowCommonDialog({ isShow: false });
      submitBSAFileUpload(validationFileUpload.values);
    } else if (data.type == "merge") {
      setShowCommonDialog({ isShow: false });
      mergeBSAFile();
    } else {
      setShowCommonDialog({ isShow: false });
    }
  };

  const mergeBSAFile = () => {
    if (selectedRefIds.length >= 2) {
      callBSAMergeSubmit({ referenceIds: selectedRefIds, entity_id: entityId })
        .then((response) => {
          if (response.status && response.code == 200) {
            const { message } = response;
            setToastInfo({
              message: message,
              showToast: true,
              role: "success",
            });
            loadBSAListData();
          } else {
            const { message } = response;
            setToastInfo({
              message: message,
              showToast: true,
              role: "error",
            });
          }

          setSelectedRefIds([]);
          setClickMergeFile(false);
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      setToastInfo({
        message: "Please select at least two files",
        showToast: true,
        role: "error",
      });
    }
  };

  const handleMergeButton = () => {
    if (clickMergeFile) {
      setShowCommonDialog({
        isShow: true,
        data: { type: "merge" },
        message: "Are you sure want to Merge Bank Details?",
      });
    }
    setClickMergeFile(true);
  }

  const handleCancelButton = () => {
    setSelectedRefIds([]);
    setClickMergeFile(false);
  };

  return (
    <React.Fragment>
      <div className="row">
        <Col xl="12">
          <Form
            className="needs-validation row"
            onSubmit={(e) => {
              e.preventDefault();
              validationFileUpload.handleSubmit();
              return false;
            }}
          >
            <div className="row">
              <Col sm="12" md="6" lg="4">
                <div className="mb-3">
                  <Label htmlFor="validationPan" className="required-sign">
                    PAN <i className="mdi mdi-asterisk"></i>
                  </Label>
                  <Input
                    name="pan"
                    placeholder="Enter PAN"
                    type="text"
                    className="form-control"
                    id="validationPan"
                    onChange={validationFileUpload.handleChange}
                    onBlur={validationFileUpload.handleBlur}
                    value={validationFileUpload.values.pan || ""}
                    invalid={
                      validationFileUpload.touched.pan &&
                      validationFileUpload.errors.pan
                    }
                  />

                  {validationFileUpload.touched.pan &&
                    validationFileUpload.errors.pan ? (
                    <FormFeedback type="invalid">
                      {validationFileUpload.errors.pan}
                    </FormFeedback>
                  ) : null}
                </div>
              </Col>
              <Col sm="12" md="6" lg="4">
                <div className=" mb-3">
                  <Label
                    htmlFor="validationEntityType"
                    className="required-sign"
                  >
                    Entity Type <i className="mdi mdi-asterisk"></i>
                  </Label>
                  <Select
                    className={`select-dropdown ${validationFileUpload.touched.entityType &&
                      validationFileUpload.errors.entityType
                      ? "is-invalid"
                      : ""
                      }`}
                    id="validationEntityType"
                    placeholder={"Select Entity Type"}
                    value={entityTypeSelected}
                    onChange={(e) => {
                      setEntityTypeSelected(e);
                      validationFileUpload.setFieldValue("entityType", e.value);
                    }}
                    options={API_SERVICES.LIST_CONSTITUTION.map((o) => {
                      return o;
                    })}
                  />
                  {validationFileUpload.touched.entityType &&
                    validationFileUpload.errors.entityType ? (
                    <FormFeedback type="invalid">
                      {validationFileUpload.errors.entityType}
                    </FormFeedback>
                  ) : null}
                </div>
              </Col>
              <Col sm="12" md="6" lg="4">
                <div className="mb-3">
                  <Label htmlFor="validationBank" className="required-sign">
                    Bank <i className="mdi mdi-asterisk"></i>
                  </Label>
                  <Select
                    className={`select-dropdown ${validationFileUpload.touched.bank &&
                      validationFileUpload.errors.bank
                      ? "is-invalid"
                      : ""
                      }`}
                    id="validationBank"
                    value={bankSelectedGroup}
                    onChange={(e) => {
                      setBankSelectedGroup(e);
                      validationFileUpload.setFieldValue("bank", e.value);
                      // bankValueChange(e.value)
                    }}
                    onKeyDown={(e) => {
                      bankValueChange(e.target.value);
                    }}
                    isLoading={isBankLoading}
                    options={bankList.map((o) => {
                      return { label: o.bankName, value: o.bankId };
                    })}
                  />
                  {validationFileUpload.touched.bank &&
                    validationFileUpload.errors.bank ? (
                    <FormFeedback type="invalid">
                      {validationFileUpload.errors.bank}
                    </FormFeedback>
                  ) : null}
                </div>
              </Col>
              <Col sm="12" md="6" lg="4">
                <div className="mb-3">
                  <Label htmlFor="validationAcName" className="required-sign">
                    Name <i className="mdi mdi-asterisk"></i>
                  </Label>
                  <Input
                    name="acName"
                    placeholder="Enter name as per bank"
                    type="text"
                    className="form-control"
                    id="validationAcName"
                    onChange={validationFileUpload.handleChange}
                    onBlur={validationFileUpload.handleBlur}
                    value={validationFileUpload.values.acName || ""}
                    invalid={
                      validationFileUpload.touched.acName &&
                        validationFileUpload.errors.acName
                        ? true
                        : false
                    }
                  />

                  {validationFileUpload.touched.acName &&
                    validationFileUpload.errors.acName ? (
                    <FormFeedback type="invalid">
                      {validationFileUpload.errors.acName}
                    </FormFeedback>
                  ) : null}
                </div>
              </Col>
              <Col sm="12" md="6" lg="4">
                <div className="mb-3">
                  <Label htmlFor="validationAcNumber" className="required-sign">
                    Account Number <i className="mdi mdi-asterisk"></i>
                  </Label>
                  <Input
                    name="acNumber"
                    placeholder="Enter Account Number"
                    type="text"
                    className="form-control"
                    id="validationAcNumber"
                    onChange={validationFileUpload.handleChange}
                    onBlur={validationFileUpload.handleBlur}
                    value={validationFileUpload.values.acNumber || ""}
                    invalid={
                      validationFileUpload.touched.acNumber &&
                      validationFileUpload.errors.acNumber
                    }
                  />

                  {validationFileUpload.touched.acNumber &&
                    validationFileUpload.errors.acNumber ? (
                    <FormFeedback type="invalid">
                      {validationFileUpload.errors.acNumber}
                    </FormFeedback>
                  ) : null}
                </div>
              </Col>
              <Col sm="12" md="6" lg="4">
                <div className=" mb-3">
                  <Label htmlFor="validationACType" className="required-sign">
                    Account Type <i className="mdi mdi-asterisk"></i>
                  </Label>
                  <Select
                    className={`select-dropdown ${validationFileUpload.touched.acType &&
                      validationFileUpload.errors.acType
                      ? "is-invalid"
                      : ""
                      }`}
                    id="validationACType"
                    value={acTypeSelected}
                    onChange={(e) => {
                      setAcTypeSelected(e);
                      validationFileUpload.setFieldValue("acType", e.value);
                    }}
                    options={acTypeSelectedOptions.map((o) => {
                      return { label: o.displayName, value: o.dropdownValue };
                    })}
                  />
                  {validationFileUpload.touched.acType &&
                    validationFileUpload.errors.acType ? (
                    <FormFeedback type="invalid">
                      {validationFileUpload.errors.acType}
                    </FormFeedback>
                  ) : null}
                </div>
              </Col>
              <Col sm="12" md="6" lg="4">
                <div className="mb-3">
                  <Label htmlFor="validationODLimit">Over Draft Limit</Label>
                  <Input
                    name="overdraftLimit"
                    placeholder="Enter Over Draft Limit"
                    type="number"
                    className="form-control"
                    id="validationODLimit"
                    onChange={validationFileUpload.handleChange}
                    onBlur={validationFileUpload.handleBlur}
                    value={validationFileUpload.values.overdraftLimit || ""}
                  />
                </div>
              </Col>

              <Col sm="12" md="6" lg="4">
                <div className="mb-3">
                  <Label htmlFor="validationStatPassword">
                    Statement Password
                  </Label>
                  <Input
                    name="statementPassword"
                    placeholder="Enter Statement Password"
                    type="password"
                    className="form-control"
                    id="validationStatPassword"
                    onChange={validationFileUpload.handleChange}
                    onBlur={validationFileUpload.handleBlur}
                    value={validationFileUpload.values.statementPassword || ""}
                  />
                </div>
              </Col>
              <Col sm="12"></Col>
              <Col sm="12" lg="4">
                <div>
                  <div className="d-flex flex-column">
                    <Label
                      htmlFor="horizontal-email-Input"
                      className="col-sm-6 col-form-label required-sign"
                    >
                      {"Upload File ( .pdf, Image)"}
                      <i className="mdi mdi-asterisk"></i>
                    </Label>
                    <div
                      className="drop"
                      onKeyUp={() => { }}
                      onClick={() => {
                        validationFileUpload.touched.fileUpload = true;
                      }}
                    >
                      <div {...getRootProps()} className="text-wrapper">
                        <div className="centered">
                          <input
                            type="file"
                            name="formatDocument"
                            id="itrFileExcel"
                            accept=".jpg, .png, .jpeg, .pdf"
                            {...getInputProps()}
                            multiple
                          />
                          <label
                            style={{
                              marginBottom: 0,
                              fontSize: "14px",
                            }}
                            htmlFor="itrFileExcel"
                          >
                            <img
                              src="https://scfuat.cashinvoice.in/frontend/assets/themes/image/icon/cloud.png"
                              className="img-fluid"
                              style={{ width: "30px" }}
                              alt="Upload"
                            />
                            {isDragActive && (
                              <p className="textLink">Drop here</p>
                            )}
                            <span className="textLink">
                              Browse files to attach
                            </span>
                            or Drop
                          </label>
                        </div>
                      </div>
                    </div>
                    {validationFileUpload.values.fileUpload && (
                      <>
                        {validationFileUpload.values.fileUpload.map(
                          (o, index) => (
                            <span className="mt-2" key={`file-${uId()}`}>
                              {o.name}{" "}
                            </span>
                          )
                        )}
                        {uploadProgress > 0 && !errorMessage && (
                          <div className="progress mt-2">
                            <div
                              className="progress-bar bg-success"
                              role="progressbar"
                              style={{ width: `${uploadProgress}%` }}
                              aria-valuenow="0"
                              aria-valuemin="0"
                              aria-valuemax="100"
                            >
                              {`${uploadProgress}%`}
                            </div>
                          </div>
                        )}
                        {errorMessage && (
                          <div className="alert alert-danger mt-2">
                            {errorMessage}
                          </div>
                        )}{" "}
                      </>
                    )}
                    {validationFileUpload.submitCount > 0 &&
                      validationFileUpload.errors.fileUpload ? (
                      <FormFeedback type="invalid" style={{ display: "block" }}>
                        {validationFileUpload.errors.fileUpload}
                      </FormFeedback>
                    ) : null}
                  </div>
                  <hr />
                </div>
              </Col>
              <Col xl="12" className="d-flex justify-content-center mb-4">
                <button
                  type="submit"
                  className="btn btn-success save-customer"
                  // disabled={loading}
                >
                  {loading && (
                    <span
                      className="spinner-border spinner-border-sm ms-2 me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  )}
                  {loading && <span>Saving</span>}
                  {!loading && <span>Save</span>}
                </button>
              </Col>
            </div>
          </Form>
        </Col>
      </div>

      <hr className="hr-divider" />
      <div className="text-end">
        {clickMergeFile && (
          <button
            className="btn btn-outline-secondary me-2"
            onClick={handleCancelButton}
          >
            Cancel
          </button>
        )}
        {bsaFileList.length > 0 && (
          <button className="btn btn-success" onClick={handleMergeButton}>
            Merged Analysis File
          </button>
        )}
      </div>
      <div className="row">
        <TableContainerV1
          columns={clickMergeFile ? bsaColumnforMergeFile : bsaColumns}
          data={bsaFileList}
          hidePageSize={true}
          hideSearchView={true}
          className="custom-header-css"
        />
      </div>
      <DeleteModal
        msg="Are you sure to delete record?"
        show={deleteDialog}
        onDeleteClick={deleteBSARecord}
        onCloseClick={() => setDeleteDialog(false)}
      />
      {showCommonDialog && (
        <CommonDialog
          isShow={showCommonDialog.isShow}
          message={showCommonDialog.message}
          data={showCommonDialog.data}
          postitiveBtn={"Submit"}
          negativeBtn={"Close"}
          onCloseFn={dialogAction}
        ></CommonDialog>
      )}
      <ToastDialog
        message={toastInfo.message || ""}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      ></ToastDialog>
    </React.Fragment>
  );
};

export default BSADocuments;
